<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
      Reports: "Relatórios",
      "Profit Sharing Bonus": "Bônus de Participação de Lucro",
      Date: "Data",
      Description: "Descrição",
      Bonus: "Bônus",
      Graduation: "Graduação",
      Quotas: "Cotas",
      "Total Received": "Total Recebido",
      "Current Month Prediction": "Previsão do Mês Atual",

      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
    },
    es: {
      Reports: "Reportes",
      "Profit Sharing Bonus": "Bono de Participación de Ganancias",
      Date: "Fecha",
      Description: "Descripción",
      Bonus: "Bono",
      Graduation: "Graduación",
      Quotas: "Cuotas",
      "Total Received": "Total Recibido",
      "Current Month Prediction": "Previsión del Mes Actual",

      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtalo de nuevo más tarde.",
      "No records found.": "No se encontraron registros.",
    },
  },
  components: {
    Layout,
    Stat,
  },
  data() {
    return {
      table: {
        heade: [
          "Date",
          "Description",
          "Bonus",
        ],
        body: null,
      },

      statData: null,
    };
  },
  methods: {
    getList() {
      this.table.body = null;

      api
        .get("reports/participacao")
        .then((response) => {
          if (response.data.status == "success") {
            this.table.body = response.data.list;

            this.statData = [
              {
                type: "line",
                icon: "bx-dollar",
                title: "Total Received",
                value: this.$options.filters.currency(response.data.total),
              },
              {
                type: "line",
                icon: "bxs-graduation",
                title: "Graduation",
                value: response.data.graduation.name,
                month: true,
              },
              {
                type: "line",
                icon: "bx-pie-chart-alt-2",
                title: "Quotas",
                value: response.data.prediction.quotas.toString(),
                month: true,
              },
              {
                type: "line",
                icon: "bx-trending-up",
                title: "Current Month Prediction",
                value: this.$options.filters.currency(response.data.prediction.bonus),
                month: true,
              },
            ];
          }
        })
        .catch(() => {
          this.table.body = []
        })
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">{{ t('Reports') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Profit Sharing Bonus') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" :month="stat.month" />
      </div>
    </div>

    <div v-if="!table.body" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="table.body && table.body.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          {{ t('No records found.') }}
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-nowrap">
            <thead class="thead-light">
              <tr>
                <th v-for="th in table.heade" :key="th">{{ t(th) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(td, index) in table.body" :key="index">
                <td v-for="(data, row) in td" :key="row" class="notranslate">
                  <div v-if="row === 'bonus'">
                    {{ data | currency }}
                  </div>
                  <div v-else>
                    {{ data }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>
